import React from 'react';

import ReactDOM from 'react-dom/client';

import * as Netfunnel from '@ecp/common/src/utils/netfunnel.d.ts';
import { getExpiredLocalStorage } from '@ecp/common/src/utils/utils';
import { setActionId } from '@ecp/common/src/utils/netfunnelUtils';

import reportWebVitals from './reportWebVitals';
import App from './App';

function rootRender() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </>
  );
}

let action_id = setActionId();

let netfunnel_pass = getExpiredLocalStorage('netfunnel_pass');

if (netfunnel_pass && netfunnel_pass == action_id) rootRender(); // 넷퍼넬 통과후 3시간이내 접속한 사용자는 패스시킴
else {
  Netfunnel.NetFunnel_Action({}, ()=> {
    rootRender();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
